"use client";

import styled from "styled-components";
import { sans as zoram, lineHeightLoose, fontSize18, fontWeightLight, fontWeightSemiBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { jsx as _jsx } from "react/jsx-runtime";
const Container1 = styled.div.withConfig({
  componentId: "sc-nsiojc-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightLight, lineHeightLoose, fontSize18, shared, fontWeightSemiBold);

/**
 * `Text1` (Body Emphasized) is used for separation of short text block from Headers / Titles and other elements
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Text content
 * @param {React.ElementType} [props.renderAs] - HTML tag or custom React element to render as
 * @returns {React.ReactElement} The Text1 component
 */
const Text1 = ({
  children,
  renderAs = "div",
  ...props
}) => /*#__PURE__*/_jsx(Container1, {
  as: renderAs,
  ...props,
  children: children
});
Text1.displayName = "Text1";
export default Text1;